module.exports = __webpack_public_path__ + "img/australia-diseases-of-the-nervous-system-male.d627ec2a.png";